/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : helper.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 30-08-2024
 * @description : Reusable functions
 */

const helper = {
  // Get the key by the value of a object
  getObjectKeyByValue: (object, value) => {
    // Check if the object is valid (not null or undefined), otherwise return "-"
    if (!object || typeof object !== "object") {
      return "-";
    }

    // return Object.keys(object)?.find(key => object[key] === value) || "-";
    const key =
      Object.keys(object)?.find((key) => object?.[key] === value) || "-";
    return key !== "-" ? key.replace(/_/g, " ") : key;
  },
  // Get the value by the key of a array of objects
  getValueByKey: (array, key) => {
    const result = array.find((item) => item.key === key);
    return result ? result.value : "-";
  },
  // Function to convert the structure
  convertKeyValueToLabel: (array) => {
    // Check if the array is valid (not null or undefined and is an array), otherwise return an empty array
    if (!Array.isArray(array)) {
      return [];
    }

    return array?.map((item) => ({
      value: item.key,
      label: item.value,
    }));
  },
  // Function to convert the structure
  convertKeyValueToLabelFiltered: (array, removeList) => {
    // Check if the array is valid (not null or undefined and is an array), otherwise return an empty array
    if (!Array.isArray(array)) {
      return [];
    }

    // Ensure removeList is an array
    removeList = Array.isArray(removeList) ? removeList : [];

    return array
      ?.filter(
        (item) => item.key !== undefined && !removeList.includes(item.key)
      )
      ?.map((item) => ({
        value: item.key,
        label: item.value,
      }));
  },
  getUserDetailsByIds: (usersDetailsList, userIds) => {
    // Ensure that the usersDetailsList, userIds is a valid array, otherwise return an empty array
    if (!Array.isArray(usersDetailsList) || !Array.isArray(userIds)) {
      return [];
    }

    // Filter the user details list to get only the users that match the provided user IDs
    return usersDetailsList?.filter((user) => userIds?.includes(user?.user_id));
  },
  truncate: (str, max = 8) => {
    if (!str) return "";
    return str.length > max ? str.substring(0, max) + "..." : str;
  },
  toSentenceCase: (text = "") => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },
};

export default helper;
